import { useState } from 'react';

/**
 * The `useMouse` function returns an object with properties and functions related to handling mouse
 * events and showing/hiding a cart.
 * @param {boolean} isShowCart - A boolean value indicating whether the cart should be shown or not.
 * @returns The useMouse function returns an object with the following properties and functions:
 */
const useMouse = (isShowCart: boolean) => {
  // cart mutatása hoverre
  const [isCartVisible, setIsCartVisible] = useState(false);

  /**
   * The handleMouseEnter function shows the cart if it is currently visible.
   */
  const handleMouseEnter = () => {
    isShowCart && setIsCartVisible(true);
  };

  /**
   * The handleMouseLeave function hides the cart if it is currently visible.
   */
  const handleMouseLeave = () => {
    isShowCart && setIsCartVisible(false);
  };

  return { isCartVisible, handleMouseEnter, handleMouseLeave };
};

export default useMouse;
